// components/errorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        this.logErrorToServer(error, errorInfo);
    }

    logErrorToServer = async (error, errorInfo) => {
        try {
            await fetch('/api/log-error', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    error: error.toString(),
                    errorInfo: errorInfo,
                    url: window.location.href,
                    timestamp: new Date().toISOString()
                })
            });
        } catch (e) {
            console.error('Failed to send error report:', e);
        }
    }

    render() {
        if (this.state.hasError) {
            return <>
                <h1>Something went wrong. Please refresh the page.</h1>
                <h2>Please report the error using <a href="https://forms.gle/gjkunm3RXdfr3uhD7">this form</a>.</h2>
                {this.state.error && this.state.error.toString()}
                {/* <details style={{ whiteSpace: 'pre-wrap' }}>
                    {this.state.error && this.state.error.toString()}
                    <br />
                    {this.state.errorInfo.componentStack}
                </details> */}
            </>
        }
        return this.props.children;
    }
}

export default ErrorBoundary;